/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import CollapsibleComponent from "./CollapsibleComponent";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";

export default function CollapsibleImage({ 
  index, 
  imgsrc, 
  name, 
  compstyle, 
  handleDownloadTiff,
  tiffLoading 
}) {
  if (!imgsrc) return null;
  
  return (
    <CollapsibleComponent
      handleDownloadTiff={handleDownloadTiff}
      tiffLoading={tiffLoading}
      index={index}
      containerOpen={`collapsible-container-open${compstyle}`}
      containerClosed={`collapsible-container-close${compstyle}`}
      headerOpen={`collapsible-header-open${compstyle}`}
      headerClosed={`collapsible-header-close${compstyle}`}
      name={name}
      child={
        <div className="tile-image-container">
          <PhotoProvider>
            <PhotoView src={imgsrc}>
              <img
                src={imgsrc}
                className="img-result-land-degradation"
                style={{
                  width: "19em",
                  height: "auto",
                  padding: "1.5em",
                  borderBottomLeftRadius: "1em",
                  borderBottomRightRadius: "1em",
                }}
              />
            </PhotoView>
          </PhotoProvider>
        </div>
      }
    />
  );
}
